var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M8 1.03245C11.8065 1.03245 14.9677 4.16206 14.9677 8.00147C14.9677 11.8732 11.8387 14.9705 8 14.9705C4.12903 14.9705 1.03226 11.8732 1.03226 8.00147C1.03226 4.16206 4.12903 1.03245 8 1.03245ZM8 0C3.58065 0 0 3.61357 0 8.00147C0 12.4216 3.58065 16.0029 8 16.0029C12.3871 16.0029 16 12.4216 16 8.00147C16 3.61357 12.3871 0 8 0ZM6.83871 11.0988C6.6129 11.0988 6.45161 11.2924 6.45161 11.486V11.7441C6.45161 11.9699 6.6129 12.1313 6.83871 12.1313H9.16129C9.35484 12.1313 9.54839 11.9699 9.54839 11.7441V11.486C9.54839 11.2924 9.35484 11.0988 9.16129 11.0988H8.77419V6.58186C8.77419 6.38827 8.58064 6.19469 8.3871 6.19469H6.83871C6.6129 6.19469 6.45161 6.38827 6.45161 6.58186V6.83997C6.45161 7.06582 6.6129 7.22714 6.83871 7.22714H7.22581V11.0988H6.83871ZM8 3.35546C7.41935 3.35546 6.96774 3.83942 6.96774 4.38791C6.96774 4.96866 7.41935 5.42035 8 5.42035C8.54839 5.42035 9.03226 4.96866 9.03226 4.38791C9.03226 3.83942 8.54839 3.35546 8 3.35546Z",
    fill: "#8B8B8B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.79a6891deab4ca2e75e5ae8edc97cfd4.svg";
export { ForwardRef as ReactComponent };